module.exports = __webpack_public_path__ + "static/media/ic-avatar.9b89ba3c.png";